import type { SVGProps } from 'react'

export const UsersIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12.5 15.8333V15.4167C12.5 13.8058 11.1942 12.5 9.58333 12.5H5.41667C3.80584 12.5 2.5 13.8058 2.5 15.4167V15.8333"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="7.50016" cy="6.24998" r="2.91667" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M18.3333 15.8333V15.4167C18.3333 13.8058 17.0275 12.5 15.4167 12.5H15"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3335 3.33331C14.9443 3.33331 16.2502 4.63915 16.2502 6.24998C16.2502 7.86081 14.9443 9.16665 13.3335 9.16665"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
